<template>
  <div class="row main-content">
    <div class="col">
      <div
        v-if="isProcessing"
        class="text-center"
      >
        <img
          src="@/assets/img/loader.gif"
          class="mx-auto d-block center-block"
        >
      </div>

      <div v-else>
        <h1 class="page-title font-custom text-uppercase mt-3">
          {{ $t('title.affiliate.details') }}
        </h1>

        <div
          v-if="responseErr"
          class="alert alert-danger text-center border-0 shadow-sm rounded-0"
        >
          <strong>
            {{ $t('error.'+`${responseErr}`) }}
          </strong>
        </div>

        <div
          v-if="hasPermission('affiliates:write') && affiliateDetail"
          class="card-body bg-light mb-4"
        >
          <BaseButton
            v-if="'CREATION'== affiliateDetail.status || 'INACTIVE'== affiliateDetail.status"
            type="button"
            class="btn btn-default btn-outline-dark rounded-pill btn-white  m-1"
            @click-base-button-event-emitter="showConfirmation (activate)"
          >
            {{ $t('button.forceActivate') }}
          </BaseButton>
          <BaseButton
            v-if="'ACTIVE'== affiliateDetail.status"
            type="button"
            class="btn btn-default btn-outline-dark rounded-pill btn-white btn-export m-1"
            @click-base-button-event-emitter="showConfirmation (inactivate)"
          >
            {{ $t('button.inactivate') }}
          </BaseButton>
          <BaseButton
            v-if="'CLOSED'!= affiliateDetail.status"
            type="button"
            class="btn btn-primary rounded-pill font-inverted btn-export m-1"
            @click-base-button-event-emitter="editAffiliate(affiliate)"
          >
            {{ $t('button.edit') }}
          </BaseButton>
        </div>

        <div v-if="affiliateDetail">
          <div
            id="accordionDetail"
            class="card rounded-0 mb-4"
          >
            <div
              id="headingOne"
              data-bs-toggle="collapse"
              href="#collapseOne"
              aria-expanded="false"
              aria-controls="collapseOne"
              class="card-header font-accent fw-bold"
            >
              {{ $t('label.affiliate.detail.detail') }}
            </div>
            <div
              id="collapseOne"
              aria-labelledby="headingOne"
              data-bs-parent="#accordionDetail"
              class="card-body collapse"
            >
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.affiliate.detail.contractId') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter(affiliateDetail.contractId) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.affiliate.detail.distributorId') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter(affiliateDetail.distributorId) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.affiliate.detail.productId') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter(affiliateDetail.productId) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.affiliate.detail.maxAmountLoad') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter(affiliateDetail.maxAmountLoad) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.affiliate.detail.minAmountLoad') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter(affiliateDetail.minAmountLoad) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.affiliate.detail.maxAmountUnload') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter(affiliateDetail.maxAmountUnload) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.affiliate.detail.minAmountUnload') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter(affiliateDetail.minAmountUnload) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.affiliate.detail.balance') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter(affiliateDetail.balance) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.affiliate.detail.mcc') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter(affiliateDetail.mcc) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.affiliate.detail.countryCode') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter(affiliateDetail.countryCode) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.affiliate.detail.address') }}
                </div>
                <div class="col">
                  <div
                    v-for="addressDetail in affiliateDetail.address"
                    :key="addressDetail"
                    class="row"
                  >
                    <div
                      v-if="addressDetail"
                      class="col"
                    >
                      {{ $filters.nullFilter(addressDetail) }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.affiliate.detail.phone1') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter(affiliateDetail.phone1) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.affiliate.detail.phone2') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter(affiliateDetail.phone2) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.affiliate.detail.email') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter(affiliateDetail.email) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.affiliate.detail.creationDate') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter(affiliateDetail.creationDate) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.affiliate.detail.status') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter(affiliateDetail.status) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.affiliate.detail.statusDate') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter(affiliateDetail.statusDate) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.affiliate.detail.activationDate') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter(affiliateDetail.activationDate) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.affiliate.detail.inactivationDate') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter(affiliateDetail.inactivationDate) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.affiliate.detail.closingDate') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter(affiliateDetail.closingDate) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.affiliate.detail.closingEffectiveDate') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter(affiliateDetail.closingEffectiveDate) }}
                </div>
              </div>
            </div>
          </div>

          <div
            id="accordionProvider"
            class="card rounded-0 mb-4"
          >
            <div
              id="heading2"
              data-bs-toggle="collapse"
              href="#collapse2"
              aria-expanded="false"
              aria-controls="collapse2"
              class="card-header font-accent fw-bold"
            >
              {{ $t('label.affiliate.detail.providerList') }}
            </div>
            <div
              id="collapse2"
              aria-labelledby="heading2"
              data-bs-parent="#accordionProvider"
              class="card-body collapse"
            >
              <!-- Attention : 'provider.providerId' may contain special characters, index is used instead-->
              <div
                v-for="(provider, index) in affiliateDetail.providerList"
                :key="provider.id"
                class="card mb-4"
              >
                <div class="card-body bg-light">
                  <div class="container pb-3">
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t('label.affiliate.detail.providerId') }}
                      </div>
                      <div class="col">
                        {{ $filters.nullFilter(provider.providerId) }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t('label.affiliate.detail.connectionMode') }}
                      </div>
                      <div class="col">
                        {{ $filters.nullFilter(provider.connectionMode) }}
                      </div>
                    </div>
                  </div>
                  <div class="card rounded-0 mb-4">
                    <!-- Attention : 'provider.providerId' may contain special characters, index is used instead-->
                    <div
                      class="card-header font-accent fw-bold"
                      data-bs-toggle="collapse"
                      :href="'#provider' + index"
                    >
                      {{ $t('label.affiliate.detail.merchantList') }}
                    </div>
                    <div
                      :id="'provider' + index"
                      class="card-body collapse"
                    >
                      <div
                        v-for="merchant in provider.merchantList"
                        :key="merchant.id"
                        class="card mb-4"
                      >
                        <div class="card-body">
                          <div class="row">
                            <div class="col-3 text-end">
                              {{ $t('label.affiliate.detail.merchantId') }}
                            </div>
                            <div class="col">
                              {{ $filters.nullFilter(merchant.merchantId) }}
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-3 text-end">
                              {{ $t('label.affiliate.detail.structureId') }}
                            </div>
                            <div class="col">
                              {{ $filters.nullFilter(merchant.structureId) }}
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-3 text-end">
                              {{ $t('label.affiliate.detail.channelList') }}
                            </div>
                            <div class="col">
                              <template v-for="channel in merchant.channelList">
                                {{ $filters.nullFilter(channel) }},
                              </template>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-3 text-end">
                              {{ $t('label.affiliate.detail.messageList') }}
                            </div>
                            <div class="col">
                              <template v-for="message in merchant.messageList">
                                {{ $filters.nullFilter(message) }},
                              </template>
                            </div>
                          </div>
                          <div
                            v-if="merchant.filteringGroup1"
                            class="row"
                          >
                            <div class="col-3 text-end">
                              {{ $t('label.affiliate.detail.IdInfosGroupeFiltrage1') }}
                            </div>
                            <div class="col">
                              <template v-for="filtering in merchant.filteringGroup1">
                                {{ $filters.nullFilter(filtering) }},
                              </template>
                            </div>
                          </div>
                          <div
                            v-if="merchant.filteringGroup2"
                            class="row"
                          >
                            <div class="col-3 text-end">
                              {{ $t('label.affiliate.detail.IdInfosGroupeFiltrage2') }}
                            </div>
                            <div class="col">
                              <template v-for="filtering in merchant.filteringGroup2">
                                {{ $filters.nullFilter(filtering) }},
                              </template>
                            </div>
                          </div>
                          <div
                            v-if="merchant.filteringGroup3"
                            class="row"
                          >
                            <div class="col-3 text-end">
                              {{ $t('label.affiliate.detail.IdInfosGroupeFiltrage3') }}
                            </div>
                            <div class="col">
                              <template v-for="filtering in merchant.filteringGroup3">
                                {{ $filters.nullFilter(filtering) }},
                              </template>
                            </div>
                          </div>
                          <div
                            v-if="merchant.filteringGroup4"
                            class="row"
                          >
                            <div class="col-3 text-end">
                              {{ $t('label.affiliate.detail.IdInfosGroupeFiltrage4') }}
                            </div>
                            <div class="col">
                              <template v-for="filtering in merchant.filteringGroup4">
                                {{ $filters.nullFilter(filtering) }},
                              </template>
                            </div>
                          </div>
                          <div
                            v-if="merchant.filteringGroup5"
                            class="row"
                          >
                            <div class="col-3 text-end">
                              {{ $t('label.affiliate.detail.IdInfosGroupeFiltrage5') }}
                            </div>
                            <div class="col">
                              <template v-for="filtering in merchant.filteringGroup5">
                                {{ $filters.nullFilter(filtering) }},
                              </template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ConfirmationDialog
      ref="confirmationDialogRef"
      @action-confirmed-event="confirmedAction()"
    />
    <SuccessDialog ref="successDialogRef" />
    <ErrorDialog ref="errorDialogRef" />
    <goTopButton />
  </div>
</template>

<script src="./AffiliateDetail.js"></script>

<style src="./AffiliateDetail.scss" scoped lang="scss"></style>
